import Vue from 'vue'
import http from '@/fetch/http'
import * as types from '@/vuex/types'

const state = {
  chapterName:"",
  sectionName:"",
  //节列表
  sectionListPage: [],
  sectionListPageNo: 1,                                    // 试节列表页面当前页数
  sectionListPageSize: types.SCROLL_LOADING.SECTION_LIST_PAGE_SIZE  // 试节列表页面每页数量
};

const actions = {
  /**
   * 查询节
   * @param commit
   * @param name
   */
  selectExerciseSection({commit}, param){
    let params = {
      chapterId: param.chapterId,
      sectionName: param.name,
      pageNo: state.sectionListPageNo,
      pageSize: state.sectionListPageSize
    };
    http.selectExerciseSection(params).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        commit("SET_BANK_LIST_PAGE", res.data);
      }
    })
  },

  /**
   * 创建节
   * @param commit
   * @param param
   */
  createSection({commit}, param){
    let params = {
      sectionName: param.sectionName,
      chapterId: param.chapterId,
      sortNumber:param.sortNumber,
    };
    http.createExerciseSection(params).then(res => {

      param.success(res);
    })
  },

  /**
   * 更新节
   * @param commit
   * @param section
   */
  updateSection({commit}, param){
    http.updateExerciseSection(param).then(res => {
      param.success(res);
    });
  },
  // 改变当前页数
  setSectionListPageNo({commit}, params){
    commit("SET_BANK_LIST_PAGE_NO", params);
  },

  /**
   * 删除节
   * @param commit
   * @param param
   */
  deleteSection({commit},param){
    http.deleteExerciseSection({sectionId:param.id}).then(res => {
      param.success(res);
    });
  },
  setSectionListPage(params) {
	  commit("SET_BANK_LIST_PAGE", params);
  }
};

const getters = {};

const mutations = {
  ['SET_BANK_LIST_PAGE'](state, page) {
    Vue.set(state, 'sectionListPage', page);
  },
  ['SET_BANK_LIST_PAGE_NO'](state, params) {
    Vue.set(state, 'sectionListPageNo', params);
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/section.js